import React from "react";
import FeatherIcon from "feather-icons-react";
import CustomModal from "src/components/configuracion/components/customModal";
import "src/components/documentostributarios/ModalDeleteObligations.scss";

function DeleteAttachmentModalContent({ attachment }) {
  const fileName = attachment?.originalFileName || attachment?.fileName || "este archivo";

  return (
    <div className="delete-obligation-modal-body">
      <div className="delete-obligation-modal-icon" aria-hidden>
        <FeatherIcon icon="trash-2" size={22} />
      </div>

      <p className="delete-obligation-modal-lead">
        ¿Eliminar <strong>{fileName}</strong>?
      </p>

      <div className="delete-obligation-modal-summary">
        <div className="delete-obligation-modal-summary-row">
          <span className="delete-obligation-modal-summary-label">Archivo</span>
          <span className="delete-obligation-modal-summary-value">{fileName}</span>
        </div>
      </div>

      <p className="delete-obligation-modal-warning">
        El archivo dejará de mostrarse y se eliminará de forma permanente en 30 días.
        Si fue un error, contacta a soporte.
      </p>
    </div>
  );
}

const DeleteAttachmentModal = ({
  open,
  onClose,
  onConfirm,
  attachment,
  isLoading = false,
}) => {
  const handleCancel = () => {
    if (!isLoading) onClose?.();
  };

  return (
    <CustomModal
      open={open}
      onClose={handleCancel}
      size="small"
      dimmer="blurring"
      closeOnDimmerClick={!isLoading}
      closeOnEscape={!isLoading}
      classNameModal="delete-obligation-modal delete-attachment-modal"
      classNameContent="delete-obligation-modal-content"
      title="Eliminar archivo"
      content={<DeleteAttachmentModalContent attachment={attachment} />}
      cancelarLabel="Cancelar"
      confirmLabel="Eliminar"
      confirmVariant="danger"
      onConfirm={onConfirm}
      confirmDisabled={isLoading}
      isLoading={isLoading}
    />
  );
};

export default DeleteAttachmentModal;
